import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  header: {
    marginBottom: theme.spacing(4),
    fontSize: 24,
  },
  charge: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  chargeAmount: {
    fontSize: 18,
    fontWeight: 700,
  },
  invoiceDescription: {
    width: '100%',
    borderRadius: 8,
    border: [1, 'solid', theme.palette.colors.border],
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(4),
  },
  invoiceValues: {
    marginRight: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
  },
  invoiceAmount: {
    marginLeft: theme.spacing(1),
  },
  fieldTitle: {
    marginBottom: theme.spacing(1),
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/UpcomingInvoice/useStyles.js